module.exports = __webpack_public_path__ + "img/zip.e8fa2025.svg";